import { render, staticRenderFns } from "./MobileSidebar.vue?vue&type=template&id=860e22d4&scoped=true"
import script from "./MobileSidebar.vue?vue&type=script&lang=js"
export * from "./MobileSidebar.vue?vue&type=script&lang=js"
import style0 from "./MobileSidebar.vue?vue&type=style&index=0&id=860e22d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "860e22d4",
  null
  
)

export default component.exports